module.exports = __webpack_public_path__ + "img/0499e6_1fa0928fdb4b4390aaa925b58e968095_mv2.c32f4ac4.webp";